export default class ApiService {

	static get $inject(){
		return [
			'$q', '$http', '$cookies',
			'ApiService'
		];
	}

	constructor($q, $http, $cookies,
	            ApiService){

		this.api = ApiService.api;
		this.errors = ApiService.errors;
		this.successes = ApiService.successes;

		this.$q = $q;
		this.$http = $http;
		this.$cookies = $cookies;

	}

	//a.res(href="https://en.wikipedia.org/wiki/Snake_case", target="_blank") Snake Case.

	get service(){
		return {

			login: {
				humanName: 'Login',
				description: '',
				name: 'login',
				request: {
					type: 'POST',
					route: '/auth/login',
					data: [
						{ name: 'email', type: 'String', description: 'Login' },
						{ name: 'password', type: 'String', description: 'Password' }
					],
					example: angular.toJson({ email: '3', password: '4444' })
				},
				response: {
					success: {
						data: [
							{ name: 'token', type: 'String', description: 'Authorization token' },
							{ name: 'role', type: 'Number', description: 'Role number: 0 - is regular user, 1 - admin' }
						]
					},
					error: {
						data: [
							this.errors.status,
							this.errors.state,
							this.errors.message
						]
					}
				},

				submit: (data)=>{
					let deferred = this.$q.defer();
					this.$http.post(this.api + '/auth/login', data)
						.then((result)=>{

							let token = result.data.token;
							this.$cookies.put('token', token);
							// console.log('> Save token to local cookies:', token.slice(0, 10) + '...' + token.slice(token.length - 10, token.length));

							deferred.resolve(result);
						})
						.catch((err)=>{
							//console.log('> Remove token from local cookies');
							//this.$cookies.remove('token');
							deferred.reject(err);
						});

					return deferred.promise;
				}
			},


			ensureUnique: {
				name: 'ensureUnique',
				request: {
					type: 'POST',
					route: '/auth/ensureUnique',
					data: [
						{ name: 'email', type: 'String', description: 'Email that should be checked' }
					],
					example: angular.toJson({ email: 'test@test.com' })
				},
				response: {
					success: {
						data: [
							{
								name: 'exists',
								type: 'Boolean',
								description: 'true - if email already exists and false if otherwise'
							}
						]
					},
					error: {
						data: [
							this.errors.status,
							this.errors.state,
							this.errors.message
						]
					}
				},
				submit: (data)=>this.$http.post(this.api + '/auth/ensureUnique', data)
			},


			forgotPassword: {
				name: 'forgotPassword',
				request: {
					type: 'POST',
					route: '/auth/forgotPassword',
					data: [
						{
							name: 'email',
							type: 'String',
							description: 'Send link to reset password form to this email if it is registered in system'
						}
					],
					example: angular.toJson({ email: 'test@test.com' })
				},
				response: {
					success: {
						data: [
							this.successes.status,
							this.successes.state,
							this.successes.message
						]
					},
					error: {
						data: [
							this.errors.status,
							this.errors.state,
							this.errors.message
						]
					}
				},
				submit: (data)=>this.$http.post(this.api + '/auth/forgotPassword', data)
			},


			resetPassword: {
				name: 'resetPassword',
				humanName: 'Reset Password',
				request: {
					type: 'POST',
					route: '/auth/resetPassword',
					data: [
						{
							name: 'accessKey',
							type: 'String',
							description: 'Reset password access key'
						},
						{
							name: 'password',
							type: 'String',
							description: 'New password'
						}
					],
					example: angular.toJson({ accessKey: '123', password: '321' })
				},
				response: {
					success: {
						data: [
							this.successes.status,
							this.successes.state,
							this.successes.message
						]
					},
					error: {
						data: [
							this.errors.status,
							this.errors.state,
							this.errors.message
						]
					}
				},
				submit: (data)=>this.$http.post(this.api + '/auth/resetPassword', data)
			},

			validatePanel: {
				humanName: 'Validate Panel',
					name: 'validatePanel',
					description: `Validate Panel in order to receive accessKey. Note: Please note , that there will be an email sent in order to validate account`,
					request: {
					contentType: 'Content-Type: application/json;charset=UTF-8',
						type: 'POST',
						route: '/personal/access/panel/validate',
						data: [
						{ name: 'mac', type: 'String', description: 'Panel MAC address' },
						{ name: 'remoteAccessPassword', type: 'Integer', description: 'Panel remote access password (1-8 digits)' },
						{ name: 'userCode', type: 'Integer', description: 'Panel user code (1-8 digits)' }
					],
						example: angular.toJson({ mac: '0013A102184B', remoteAccessPassword: '54541741', userCode: '1234'})
				},
				response: {
					success: { data: [
						{ name: 'accessKey', type: 'String', description: 'Access Key that is need to sign-up' },
						this.successes.status,
						this.successes.state,
						this.successes.message
					] },
					error: { data: [
						this.errors.status,
						this.errors.state,
						this.errors.message
					] }
				},
				submit: (data)=>
					this.$http({
						url: this.api + '/personal/access/panel/validate',
						method: 'POST',
						data: data,
						headers: { Authorization: 'Bearer ' + this.$cookies.get('token') }
					})
			},
			createAccountWithAccessKey: {
				name: 'createAccountWithAccessKey',
				humanName: 'Create new Account with AccessKey',
				request: {
					type: 'POST',
					route: '/auth/create',
					data: [
						{
							name: 'login',
							type: 'Email',
							description: 'Login'
						},
						{
							name: 'name',
							type: 'String',
							description: 'Name'
						},
						{
							name: 'lastName',
							type: 'String',
							description: 'Last name'
						},
						{
							name: 'panelName',
							type: 'String',
							description: 'Name of Panel'
						},
						{
							name: 'accessKey',
							type: 'String',
							description: 'Panel validation access key'
						},
						{
							name: 'password',
							type: 'String',
							description: 'New password'
						},
						{ name: 'userCode', type: 'Integer', description: 'Panel user code (1-8 digits)' }
					],
					example: angular.toJson({"name":"Fedor","userCode":1234,"lastName":"BACiLKOB","password":"1234","login":"fedor","accessKey":"e26d697b-bf8b-4a07-b99b-c38cb5a31362"})
				},
				response: {
					success: {
						data: [
							this.successes.status,
							this.successes.state,
							this.successes.message
						]
					},
					error: {
						data: [
							this.errors.status,
							this.errors.state,
							this.errors.message
						]
					}
				},
				submit: (data)=>this.$http.post(this.api + '/auth/create', data)
			}
		}
	}


}



/** WEBPACK FOOTER **
 ** ./src/main/apiTest/services/api.service.auth.js
 **/